'use client';

import { ProfileDetailScreen } from '@ninjacart/nc-nk-profile';
import { ReportFastContextProvider } from '@ninjacart/nc-nk-store';
import { ReportBottomSheet } from '@ninjacart/nc-nk-ui';
import { Platform } from 'react-native';
import { View, YStack } from 'tamagui';
import Footer from '../../components/footer';

export default function ProfileDetailLayout() {
  return (
    <>
      <YStack fullscreen>
         <ReportFastContextProvider>
            <ProfileDetailScreen />
            <ReportBottomSheet />
          </ReportFastContextProvider>
      </YStack>
    </>
  );
}
